import {
  CButton,
  CDropdown,
  CDropdownMenu,
  CDropdownToggle
} from "@coreui/react"
import { format } from "date-fns"
import PropTypes from "prop-types"
import React from "react"
import { FaRegClock } from "react-icons/fa"

function TimePickerInput({
  className,
  buttonClassName,
  emptyText,
  onChange,
  value
}) {
  const selectedTime = new Date()
  if (value?.split(":")[0] && value?.split(":")[1]) {
    selectedTime.setHours(value?.split(":")[0], value?.split(":")[1])
  }

  const selectedHour = selectedTime.getHours() % 12 || 12
  const selectedMin = selectedTime.getMinutes()
  const selectedMeridiem = format(selectedTime, "aa")

  const handleChange = (hour, min, meridiem) => {
    onChange(
      `${`0${
        meridiem === "PM" ? (hour === 12 ? 12 : hour + 12) : hour % 12
      }`.slice(-2)}:${("0" + min).slice(-2)}`
    )
  }

  return (
    <CDropdown className={className}>
      <CDropdownToggle
        className={`bg-white text-dark d-flex align-items-center justify-content-between ${buttonClassName}`}
        caret
      >
        {value || emptyText}
        <FaRegClock size="20px" className="ml-3" />
      </CDropdownToggle>
      <div className="invalid-feedback">This field is required</div>
      <CDropdownMenu className="p-0 overflow-hidden">
        <div className="d-flex max-height-inherit">
          <div className="d-flex flex-column max-height-inherit overflow-auto time-picker-scroll">
            {Array.from({ length: 12 }, (_, i) => i + 1).map((hour) => (
              <CButton
                key={hour}
                className={`time-btn ${
                  hour === selectedHour ? "active" : ""
                }`}
                onClick={() =>
                  handleChange(hour, selectedMin, selectedMeridiem)
                }
              >
                {("0" + hour).slice(-2)}
              </CButton>
            ))}
          </div>
          <div className="d-flex flex-column max-height-inherit overflow-auto time-picker-scroll">
            {Array.from({ length: 60 }, (_, i) => i).map((minute) => (
              <CButton
                key={minute}
                className={`time-btn ${
                  minute === selectedMin ? "active" : ""
                }`}
                onClick={() =>
                  handleChange(selectedHour, minute, selectedMeridiem)
                }
              >
                {("0" + minute).slice(-2)}
              </CButton>
            ))}
          </div>
          <div className="d-flex flex-column max-height-inherit overflow-auto hide-scrollbar">
            {["AM", "PM"].map((meridiem) => (
              <CButton
                key={meridiem}
                className={`time-btn ${
                  meridiem === selectedMeridiem ? "active" : ""
                }`}
                onClick={() =>
                  handleChange(selectedHour, selectedMin, meridiem)
                }
              >
                {meridiem}
              </CButton>
            ))}
          </div>
        </div>
      </CDropdownMenu>
    </CDropdown>
  )
}

TimePickerInput.defaultProps = {
  className: "",
  buttonClassName: "",
  onChange: () => {},
  emptyText: "No time Selected"
}

TimePickerInput.propTypes = {
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  emptyText: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string
}

export default TimePickerInput
